const ResponseFormat = () => {
  return {
    result: true,
    param: {},
    warning: {
      title: '入力が正しくありません',
      message: [],
      type: 'is-warning',
      hasIcon: true
    }
  }
}

const WarningMessage = {
  model: '・モデルが選択されていません',
  dataFile: '・ファイルが選択されていません',
  dataJSON: '・データが入力されていません',
  dataJSONInvalid: '・データがJSON形式でありません'
}

class ScoringValidator {

  static validate (form) {

    let response = ResponseFormat()
    const scoringType = form.scoringType

    response = this._validateModel(form.model, response)

    if (scoringType === 0) {
      response = this._validateDataFile(form.dataFile, response)
    } else if (scoringType === 1) {
      response = this._validateDataJSON(form.dataJSON, response)
    }

    if (!response.result) {
      response.warning.message = response.warning.message.join('<br>')
    }

    return response
  }

  static _validateModel (model, response) {
    if (model) {
      response.param['model_id'] = model
    } else {
      response = this._packingWarningStatus(response, 'model')
    }
    return response
  }

  static _validateDataFile (dataFile, response) {
    if (dataFile) {
      response.param['file_name'] = dataFile.name
      response.param['transaction_id'] = ''
    } else {
      response = this._packingWarningStatus(response, 'dataFile')
    }
    return response
  }

  static _validateDataJSON (dataJSON, response) {
    if (dataJSON) {
      try {
        response.param['data'] = JSON.parse(dataJSON).data
      } catch (e) {
        response = this._packingWarningStatus(response, 'dataJSONInvalid')
      }
    } else {
      response = this._packingWarningStatus(response, 'dataJSON')
    }
    return response
  }

  static _packingWarningStatus (response, key) {
    response.result = false
    response.warning.message.push(WarningMessage[key])
    return response
  }
}

class BundlingValidator {

  static validate (form) {

    let response = ResponseFormat()
    const scoringType = form.scoringType

    response = this._validateModel(form.model, response)

    if (scoringType === 0) {
      response = this._validateDataFile(form.dataFile, response)
    } else if (scoringType === 1) {
      response = this._validateDataJSON(form.dataJSON, response)
    }

    if (!response.result) {
      response.warning.message = response.warning.message.join('<br>')
    }

    return response
  }

  static _validateModel (model, response) {
    if (model) {
      response.param['model_id'] = model
    } else {
      response = this._packingWarningStatus(response, 'model')
    }
    return response
  }

  static _validateDataFile (dataFile, response) {
    if (dataFile) {
      response.param['file_name'] = dataFile.name
      response.param['transaction_id'] = ''
    } else {
      response = this._packingWarningStatus(response, 'dataFile')
    }
    return response
  }

  static _validateDataJSON (dataJSON, response) {
    if (dataJSON) {
      try {
        response.param['data'] = JSON.parse(dataJSON).data
      } catch (e) {
        response = this._packingWarningStatus(response, 'dataJSONInvalid')
      }
    } else {
      response = this._packingWarningStatus(response, 'dataJSON')
    }
    return response
  }

  static _packingWarningStatus (response, key) {
    response.result = false
    response.warning.message.push(WarningMessage[key])
    return response
  }
}

export {ScoringValidator}



// WEBPACK FOOTER //
// ./src/modules/validation.js